<template>
  <router-view />
</template>
<script>
export default {
  name: "Establecimientos",
};
</script>

<style scoped></style>
